import { database } from '../firebase/firebase';
import { ref, get } from 'firebase/database';

export const productService = {
  // Get all products
  getAllProducts: async () => {
    try {
      const productsRef = ref(database, 'products');
      const snapshot = await get(productsRef);
      
      if (!snapshot.exists()) {
        return [];
      }
  
      const productsData = snapshot.val();
  
      return Object.keys(productsData)
        .map(key => ({
          id: key,
          ...productsData[key]
        }))
        .filter(product => product.product_isComplete === true); 
  
    } catch (error) {
      console.error("Error fetching products:", error);
      throw error;
    }
  },
  

  // Get approved products
  getApprovedProducts: async () => {
    try {
      const allProducts = await productService.getAllProducts();
      return allProducts.filter(product => product.product_certification_status === 'Approved');
    } catch (error) {
      console.error("Error fetching approved products:", error);
      throw error;
    }
  },

  // Get pending products
  getPendingProducts: async () => {
    try {
      const allProducts = await productService.getAllProducts();
      return allProducts.filter(product => 
        product.product_certification_status === 'Pending' && 
        product.product_isComplete === true
      );
    } catch (error) {
      console.error("Error fetching pending products:", error);
      throw error;
    }
  },
  

  // Get products by certification status
  getProductsByCertificationStatus: async (status) => {
    try {
      const allProducts = await productService.getAllProducts();
      return allProducts.filter(product => product.product_certification_status === status);
    } catch (error) {
      console.error(`Error fetching ${status} products:`, error);
      throw error;
    }
  }, 

  // Get rejected products
  getRejectedProducts: async () => {
  try {
    const allProducts = await productService.getAllProducts();
    return allProducts.filter(product => product.product_certification_status === 'Rejected');
  } catch (error) {
    console.error("Error fetching rejected products:", error);
    throw error;
  }
}
};